"use strict";
// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
Object.defineProperty(exports, "__esModule", { value: true });
var borderWidths = {
    "thick": "2px",
    "regular": "1px"
};
exports.default = borderWidths;
//# sourceMappingURL=borderWidths.js.map